/*
 *
 * Results constants
 *
 */

export const SLICE_NAME = 'results';


export const REDUCED_VIEW_BREAKPOINT = 770;
export const MOBILE_PADDING = 20;